import React, { useState } from "react"
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Card,
  CardBody,
} from "reactstrap"

import ArrowDown from "../../../assets/images/arrow-down.png"
import ArrowUp from "../../../assets/images/arrow-up.png"
import Breadcrumb from "components/Common/Breadcrumb"

const FaqSearchResult = ({ data }) => {
  const [open, setOpen] = useState(0)
  const toggleFaq = (id) => {
    if (open === id) {
      setOpen()
    } else {
      setOpen(id)
    }
  }

  return (
    <Card>
      <div className="page-search-title">
        <Breadcrumb title={data.title} />
      </div>
      <CardBody>
        <div className="accordion-wrapper-section mt-5">
          <Accordion open={open} toggle={toggleFaq}>
            {data.data.map((item, index) => (
              <AccordionItem key={index}>
                <AccordionHeader targetId={index}>
                  {item.question}
                  <div className="">
                    {open === "1" ? (
                      <img src={ArrowUp} alt="" />
                    ) : (
                      <img src={ArrowDown} alt="" />
                    )}
                  </div>
                </AccordionHeader>
                <AccordionBody accordionId={index}>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: item.answer,
                    }}
                  />
                </AccordionBody>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </CardBody>
    </Card>
  )
}

export default FaqSearchResult
